// MobileProcessFlow.js - Updated Version
import React from 'react';
import ProcessStep from './processstep';
import ConnectionLines from './connectionline';

const MobileProcessFlow = ({
  isSectionInView,
  visibleSteps,
  hoveredStep,
  animationStarted,
  processSteps,
  expandedSteps,
  shouldAnimateOut,
  onStepClick,
  onMouseEnter,
  onMouseLeave
}) => {
  // Group steps into pairs (2 steps per row), handle last step separately
  const stepPairs = [];
  for (let i = 0; i < processSteps.length - 1; i += 2) {
    stepPairs.push(processSteps.slice(i, i + 2));
  }
  
  // Add the last step separately for centering
  const lastStep = processSteps[processSteps.length - 1];

  return (
    <div style={{ 
      display: window.innerWidth <= 992 ? 'block' : 'none',
      maxWidth: '600px',
      margin: '0 auto',
      position: 'relative',
      padding: '5px 0 10px 0', // Reduced top and bottom padding
    }}>
      {/* Updated Connection Lines for Mobile with visibleSteps prop */}
      <ConnectionLines 
        isSectionInView={isSectionInView}
        animationStarted={animationStarted}
        processSteps={processSteps}
        visibleSteps={visibleSteps}
        shouldAnimateOut={shouldAnimateOut}
        isMobile={true}
      />
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '30px', // Reduced from 30px/20px
        position: 'relative',
        zIndex: 2,
        marginBottom: '0', // Ensure no margin bottom
        paddingBottom: '10px', // Minimal padding
      }}>
        {/* Render all step pairs */}
        {stepPairs.map((pair, rowIndex) => (
          <div key={rowIndex} style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            minHeight: '120px', // Reduced from 120px/100px
            position: 'relative',
            marginBottom: '0', // No margin between rows
          }}>
            {pair.map((step, stepIndex) => {
              const globalIndex = (rowIndex * 2) + stepIndex;
              const isStepVisible = visibleSteps.includes(globalIndex);
              const isExpanded = expandedSteps[globalIndex] || false;
              
              return (
                <ProcessStep
                  key={step.id}
                  step={step}
                  index={globalIndex}
                  isStepVisible={isStepVisible}
                  isHovered={hoveredStep === globalIndex}
                  isExpanded={isExpanded}
                  isLeftSide={stepIndex === 0}
                  shouldAnimateOut={shouldAnimateOut}
                  onStepClick={onStepClick}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                  isDesktop={false}
                />
              );
            })}
          </div>
        ))}
        
        {/* Last step centered */}
        <div key="last-step" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minHeight: '90px', // Reduced from 120px/100px
          position: 'relative',
          marginBottom: '0', // No margin bottom
        }}>
          <ProcessStep
            key={lastStep.id}
            step={lastStep}
            index={processSteps.length - 1}
            isStepVisible={visibleSteps.includes(processSteps.length - 1)}
            isHovered={hoveredStep === processSteps.length - 1}
            isExpanded={expandedSteps[processSteps.length - 1] || false}
            isLeftSide={false}
            isCentered={true}
            shouldAnimateOut={shouldAnimateOut}
            onStepClick={onStepClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            isDesktop={false}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileProcessFlow;